




















































import { Component, Vue, Prop } from "vue-property-decorator";
import StandartFaq, { IFaqStep } from "@/components/app/standart-faq.vue";

@Component({
  components: { StandartFaq },
})
class RouteInfoDashbordHeader extends Vue {
  @Prop({ type: String, default: "route" }) readonly listVariant!: string;
  @Prop({ type: Boolean, default: false }) readonly showTrash!: boolean;

  get faqSteps(): Array<IFaqStep> {
    return [
      { icon: "building", text: String(this.$t("route_info.faq.step1")) },
      { icon: "map", text: String(this.$t("route_info.faq.step2")) },
      { icon: "check-circle", text: String(this.$t("route_info.faq.step3")) },
    ];
  }
}
export default RouteInfoDashbordHeader;
